import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M11 7l-5 5l5 5","key":"svg-0"}],["path",{"d":"M17 7l-5 5l5 5","key":"svg-1"}]]

/**
 * IconChevronsLeft
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItY2hldnJvbnMtbGVmdCIKPgogIDxwYXRoIHN0cm9rZT0ibm9uZSIgZD0iTTAgMGgyNHYyNEgweiIgZmlsbD0ibm9uZSIgLz4KICA8cGF0aCBkPSJNMTEgN2wtNSA1bDUgNSIgLz4KICA8cGF0aCBkPSJNMTcgN2wtNSA1bDUgNSIgLz4KPC9zdmc+) - https://tabler.io/icons/icon/chevrons-left
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconChevronsLeft = createReactComponent('outline', 'chevrons-left', 'ChevronsLeft', __iconNode);

export default IconChevronsLeft;